import PropTypes from 'prop-types'
import React from 'react'
import { LanguageSelector } from '../options'
import Affiliate from './components/AffiliateOld'
import Background from './components/BackgroundOld'
import Title from './components/Title'
import Tracking from './components/Tracking'
import Typography from './components/Typography'

function CommonWithoutSeoSettings({ isSkipFont }) {
  return (
    <React.Fragment>
      <Title />
      <Typography skipFont={isSkipFont} />
      <LanguageSelector />
      <Background />
      <Tracking />
      <Affiliate />
    </React.Fragment>
  )
}

Typography.CommonWithoutSeoSettings = {
  isSkipFont: PropTypes.bool,
}

export default CommonWithoutSeoSettings
